function generatePrompt(testName, type, vendor, exam_time, total_marks, exam_code, domain, noOfQuestions, gradeLevel, assessmentLevel, isScenarioBased, language,passage,caseStudyOption,mediaUrl,directAttachmentType,extraPromptText) {
    let prompt = "";
    // console.log(testName, type, vendor, exam_time, total_marks, exam_code, domain, noOfQuestions, gradeLevel, assessmentLevel, isScenarioBased, language,passage,mediaUrl)
    if (passage||mediaUrl||directAttachmentType) {
      if(caseStudyOption === 'generateImage'|| directAttachmentType==='image')
      {
        if(caseStudyOption === 'generateImage')
        {
prompt = `Generate ${noOfQuestions} unique multiple-choice questions based on the uploaded image and domain structure.\n\n`;
      }
      if(caseStudyOption === 'image')
        {
prompt = `Generate ${noOfQuestions} unique multiple-choice questions referring the uploaded image and domain structure.\n\n`;
      }
    }
      else{
        if(directAttachmentType==='pdf')
        {
prompt = `Generate ${noOfQuestions} unique multiple-choice questions referring the attach file and domain structure.\n\n`;
        }
        else
        {
prompt = `Generate ${noOfQuestions} unique multiple-choice questions based on the script and domain structure.\n\n`;
      }
      }
 if (caseStudyOption === 'generateImage'||directAttachmentType==='image')
    {
  
  // prompt += `<img src="data:image/png;base64,${passage}" alt="Generated Image" style="height: 400px; width: 100%;" />\n\n`;

    }
  // Add script
  else
  {
  prompt += `- **Script**: "${passage}"\n\n`;
  }
   if(extraPromptText!=='')
  {
    prompt += extraPromptText + '\n\n'
  }
  // Add domain and subdomain structure for reference
  prompt += `- **Domains**: Use the following domain and subdomain structure to assign domain_id and sub_domain_id in each question (do not include the full structure in your response):\n`;
  
  const formattedSubdomains = Array.isArray(domain.subDomain)
    ? domain.subDomain.map(subDomain => ({
        sub_domain_id: subDomain.sub_domain_id,
        name: subDomain.name,
        sub_topics: subDomain.sub_topics
      }))
    : [];

  const formattedDomain = {
    domain_id: domain.domain_id,
    name: domain.name,
    percentage: domain.percentage,
    subDomain: formattedSubdomains
  };
  //console.log(formattedDomain)
  prompt += `${JSON.stringify(formattedDomain, null, 2)}\n\n`;

  // Add formatting instructions
  prompt += `\nPlease format each question as a JSON object within a list, following the example provided. Your response must strictly contain only the list of questions in JSON format—no extra text.\n\n`;

  // JSON format example
  prompt += `Example Format:\njson\n[\n  {\n    "question": "Question content",\n    "domain_id": "Domain ID",\n    "sub_domain_id": "Sub-Domain ID",\n    "mimeType": "Text",\n    "percentage": 85,\n    "active": 1,\n    "keywords": "Keyword1,Keyword2,Keyword3",\n    "hint": "Hint for the question",\n    "explanation": "Explanation of the correct answer",\n    "answer": [\n      {"answer": "Option 1", "is_correct": 0},\n      {"answer": "Option 2", "is_correct": 1},\n      {"answer": "Option 3", "is_correct": 0},\n      {"answer": "Option 4", "is_correct": 0}\n    ]\n  }\n]\n`;
  //console.log(prompt)
  return prompt;
}

        prompt = `Generate ${noOfQuestions} unique multiple-choice `;
        prompt += isScenarioBased ? `scenario-based ` : ``;
        prompt += `questions from the specified domains and subdomains, including subtopic details.\n\n`;
    prompt += `- **Test Name**: "${testName}"\n`;
    prompt += `- **Type**: "Course"\n`;
    prompt += `- **Mime Type**: "${type}"\n`;
    prompt += `- **Vendor**: "${vendor}"\n`;
    prompt += `- **Language**: "${language}"\n`;
    prompt += `- **Exam Time**: "${exam_time}"\n`;
    prompt += `- **Total Marks**: "${total_marks}"\n`;
    prompt += `- **Exam Code**: "${exam_code}"\n`;

    if (gradeLevel) {
        prompt += `- **Grade Level**: "${gradeLevel}"\n`;
    }
    if (assessmentLevel && assessmentLevel.length > 0) {
        prompt += `- **Assessment Level**: "Bloom's Taxonomy: ${assessmentLevel}"\n`;
    }

     if(extraPromptText!=='')
  {
    prompt += extraPromptText + '\n\n'
  }

    prompt += `- **Domains**: `;
        const formattedSubdomains = Array.isArray(domain.subDomain)
            ? domain.subDomain.map(subDomain => ({
                  sub_domain_id: subDomain.sub_domain_id,
                  testId: "",
                  name: subDomain.name,
                  sub_topics: subDomain.sub_topics,
                  active: 0,
                  created_at: "",
                  updated_at: "",
              }))
            : [];

        const formattedDomain = {
            name: domain.name,
            domain_id: domain.domain_id,
            percentage: domain.percentage,
            subDomain: formattedSubdomains,
        };
        //console.log(formattedDomain)
        prompt += JSON.stringify(formattedDomain, null, 2);

       if (type === "Text") {
        prompt += `\nPlease format each question as a JSON object within a list, following the example provided. Ensure strict adherence to the given format; any deviation will result in an error and the "Domain" value should remain exactly the same as specified in the "Domain" field at the beginning of this prompt.\n\nExample Question Format (as a list of questions):\njson\n[\n  {\n    "question": "Question content",\n    "domain_id": "Domain ID",\n    "sub_domain_id": "Sub-Domain ID",\n    "mimeType": "Mime Type",\n    "percentage": 85,\n    "active": 1,\n    "keywords": "Keyword1,Keyword2,Keyword3",\n    "hint": "Hint for the question",\n    "explanation": "Explanation of the correct answer",\n    "answer": [\n      {"answer": "Option 1", "is_correct": 0},\n      {"answer": "Option 2", "is_correct": 1},\n      {"answer": "Option 3", "is_correct": 0},\n      {"answer": "Option 4", "is_correct": 0}\n    ]\n  }\n]`;
    } else if (type === "Image") {
        prompt += `\nPlease format each question as a JSON object within a list, following the example provided. Note: Don't give links in the prompt field, the prompt field should have a valid text-based prompt which can be used further in generating images from DALLE-3. Ensure strict adherence to the given format; any deviation will result in an error and the "Domain" value should remain exactly the same as specified in the "Domain" field at the beginning of this prompt.\n\nExample Question Format (as a list of questions):\njson\n[\n  {\n    "question": "Question content",\n    "domain_id": "Domain ID",\n    "sub_domain_id": "Sub-Domain ID",\n    "mimeType": "Mime Type",\n    "prompt": "prompt",\n    "percentage": 85,\n    "active": 1,\n    "keywords": "Keyword1,Keyword2,Keyword3",\n    "hint": "Hint for the question",\n    "explanation": "Explanation of the correct answer",\n    "answer": [\n      {"answer": "Option 1", "is_correct": 0},\n      {"answer": "Option 2", "is_correct": 1},\n      {"answer": "Option 3", "is_correct": 0},\n      {"answer": "Option 4", "is_correct": 0}\n    ]\n  }\n]`;
    }

    return prompt;
}

export { generatePrompt };


function generatePromptCopy(testName, type, vendor, exam_time, total_marks, exam_code, domains, noOfQuestions, gradeLevel, assessmentLevel, isScenarioBased,language, passage,caseStudyOption,mediaUrl,directAttachmentType,extraPromptText) {
    let prompt = "";
    console.log(extraPromptText)
    if (passage||mediaUrl||directAttachmentType) {
      if(caseStudyOption === 'generateImage'||( directAttachmentType==='image'))
      {
prompt = `Generate ${noOfQuestions} unique multiple-choice questions based on the attached image and domain structure.\n\n`;
      }
      else{
          if(directAttachmentType==='pdf')
        {
prompt = `Generate ${noOfQuestions} unique multiple-choice questions referring the script and domain structure.\n\n`;
        }
        else{
prompt = `Generate ${noOfQuestions} unique multiple-choice questions based on the script and domain structure.\n\n`;
      }
    }
   if (caseStudyOption === 'generateImage'||( directAttachmentType==='image')) 
    {
      if(directAttachmentType==='image')
      {
  //prompt += `<img src="${mediaUrl}" alt="Generated Image" style="height: 400px; width: 100%;" />\n\n`;
}
    }
  // Add script
  else
  {
  prompt += `- **Script**: "${passage}"\n\n`;
  }

   if(extraPromptText!=='')
  {
    prompt += extraPromptText + '\n\n'
  }
  // Add domain and subdomain structure for reference
  prompt += `- **Domains**: Use the following domain and subdomain structure to assign domain_id and sub_domain_id in each question (do not include the full structure in your response):\n`;
  
  const formattedDomains = domains.map(domain => {
        const formattedSubdomains = domain.subDomain.map(subDomain => ({
            sub_domain_id: subDomain.sub_domain_id,
            domain_id: subDomain.domain_id,
            name: subDomain.name,
            sub_topics: subDomain.sub_topics,
            active: subDomain.active,
            created_at: subDomain.created_at,
            updated_at: subDomain.updated_at,
        }));

        return {
            domain_id: domain.domain_id,
            name: domain.name,
            percentage: domain.percentage,
            active: domain.active,
            created_at: domain.created_at,
            updated_at: domain.updated_at,
            subDomain: formattedSubdomains,
        };
    });
  //console.log(formattedDomains)
  prompt += `${JSON.stringify(formattedDomains, null, 2)}\n\n`;

  // Add formatting instructions
  prompt += `\nPlease format each question as a JSON object within a list, following the example provided. Your response must strictly contain only the list of questions in JSON format—no extra text.\n\n`;

  // JSON format example
  prompt += `Example Format:\njson\n[\n  {\n    "question": "Question content",\n    "domain_id": "Domain ID",\n    "sub_domain_id": "Sub-Domain ID",\n    "mimeType": "Text",\n    "percentage": 85,\n    "active": 1,\n    "keywords": "Keyword1,Keyword2,Keyword3",\n    "hint": "Hint for the question",\n    "explanation": "Explanation of the correct answer",\n    "answer": [\n      {"answer": "Option 1", "is_correct": 0},\n      {"answer": "Option 2", "is_correct": 1},\n      {"answer": "Option 3", "is_correct": 0},\n      {"answer": "Option 4", "is_correct": 0}\n    ]\n  }\n]\n`;

  return prompt;
}



        prompt = `Generate ${noOfQuestions} unique multiple-choice `;
        prompt += isScenarioBased ? `scenario-based ` : ``;
        prompt += `questions from the specified domains and subdomains, including subtopic details.\n\n`;

    // Add basic test details
    prompt += `- **Test Name**: "${testName}"\n`;
    prompt += `- **Type**: "Course"\n`;
    prompt += `- **Mime Type**: "${type}"\n`;
    prompt += `- **Vendor**: "${vendor}"\n`;
    prompt += `- **Language**: "${language}"\n`;
    prompt += `- **Exam Time**: "${exam_time}"\n`;
    prompt += `- **Total Marks**: "${total_marks}"\n`;
    prompt += `- **Exam Code**: "${exam_code}"\n`;

    // Add optional grade level
    if (gradeLevel) {
        prompt += `- **Grade Level**: "${gradeLevel}"\n`;
    }

    // Add assessment level if available
    if (assessmentLevel && assessmentLevel.length > 0) {
        prompt += `- **Assessment Level**: "Bloom's Taxonomy: ${assessmentLevel}"\n`;
    }

     if(extraPromptText!=='')
  {
    prompt += extraPromptText + '\n\n'
  }

    // Add domains section
    prompt += `- **Domains**:\n`;

    // Format each domain and its subdomains
    const formattedDomains = domains.map(domain => {
        const formattedSubdomains = domain.subDomain.map(subDomain => ({
            sub_domain_id: subDomain.sub_domain_id,
            domain_id: subDomain.domain_id,
            name: subDomain.name,
            sub_topics: subDomain.sub_topics,
            active: subDomain.active,
            created_at: subDomain.created_at,
            updated_at: subDomain.updated_at,
        }));

        return {
            domain_id: domain.domain_id,
            name: domain.name,
            percentage: domain.percentage,
            active: domain.active,
            created_at: domain.created_at,
            updated_at: domain.updated_at,
            subDomain: formattedSubdomains,
        };
    });
    
    // Append formatted domains to the prompt
    prompt += JSON.stringify(formattedDomains, null, 2);

        // Add example question format based on MIME type
        if (type === "Text") {
        prompt += `\nPlease format each question as a JSON object within a list, following the example provided. Ensure strict adherence to the given format; any deviation will result in an error and the "Domain" value should remain exactly the same as specified in the "Domain" field at the beginning of this prompt.\n\nExample Question Format (as a list of questions):\njson\n[\n  {\n    "question": "Question content",\n    "domain_id": "Domain ID",\n    "sub_domain_id": "Sub-Domain ID",\n    "mimeType": "Mime Type",\n    "percentage": 85,\n    "active": 1,\n    "keywords": "Keyword1,Keyword2,Keyword3",\n    "hint": "Hint for the question",\n    "explanation": "Explanation of the correct answer",\n    "answer": [\n      {"answer": "Option 1", "is_correct": 0},\n      {"answer": "Option 2", "is_correct": 1},\n      {"answer": "Option 3", "is_correct": 0},\n      {"answer": "Option 4", "is_correct": 0}\n    ]\n  }\n]`;
    } else if (type === "Image") {
        prompt += `\nPlease format each question as a JSON object within a list, following the example provided. Note: Don't give links in the prompt field, the prompt field should have a valid text-based prompt which can be used further in generating images from DALLE-3. Ensure strict adherence to the given format; any deviation will result in an error and the "Domain" value should remain exactly the same as specified in the "Domain" field at the beginning of this prompt.\n\nExample Question Format (as a list of questions):\njson\n[\n  {\n    "question": "Question content",\n    "domain_id": "Domain ID",\n    "sub_domain_id": "Sub-Domain ID",\n    "mimeType": "Mime Type",\n    "prompt": "prompt",\n    "percentage": 85,\n    "active": 1,\n    "keywords": "Keyword1,Keyword2,Keyword3",\n    "hint": "Hint for the question",\n    "explanation": "Explanation of the correct answer",\n    "answer": [\n      {"answer": "Option 1", "is_correct": 0},\n      {"answer": "Option 2", "is_correct": 1},\n      {"answer": "Option 3", "is_correct": 0},\n      {"answer": "Option 4", "is_correct": 0}\n    ]\n  }\n]`;
    }

    return prompt;
}

export { generatePromptCopy };

function generatePassagePrompt({
  testName,
  mimeType,
  vendor,
  language,
  examTime,
  totalMarks,
  examCode,
  gradeLevel,
  assessmentLevel,
  domains,
  Title
}) {
  let prompt = `
You are an educational content generator. Create a high-quality English reading comprehension passage`
if(Title) 
{
  prompt=prompt+`based on the title ${Title} and `
}

prompt = prompt + `suitable for a ${gradeLevel} student.

Use the following metadata to guide the passage content and structure:
- **Test Name**: ${testName}
- **Mime Type**: ${mimeType}
- **Vendor**: ${vendor}
- **Language**: ${language}
- **Exam Time**: ${examTime} minutes
- **Total Marks**: ${totalMarks}
- **Exam Code**: ${examCode}
- **Grade Level**: ${gradeLevel}
- **Assessment Level**: ${assessmentLevel}
- **Domains**: Use the following domain and subdomain structure to understand focus areas (do not include this structure in your response):
`;

  // Format domains and subdomains like generatePromptCopy
  const formattedDomains = domains.map(domain => {
    const formattedSubdomains = domain.subDomain.map(subDomain => ({
      sub_domain_id: subDomain.sub_domain_id,
      domain_id: subDomain.domain_id,
      name: subDomain.name,
      sub_topics: subDomain.sub_topics,
      active: subDomain.active,
      created_at: subDomain.created_at,
      updated_at: subDomain.updated_at
    }));

    return {
      domain_id: domain.domain_id,
      name: domain.name,
      percentage: domain.percentage,
      active: domain.active,
      created_at: domain.created_at,
      updated_at: domain.updated_at,
      subDomain: formattedSubdomains
    };
  });

  prompt += `${JSON.stringify(formattedDomains, null, 2)}\n`;

  prompt += `
**Passage Requirements**:
- Topic: Choose an age-appropriate and engaging fictional or historical story
- Length: Suitable for a ${examTime}-minute read and comprehension exam
- Objective: Enable students to identify the main idea, supporting details, and make inferences
- Style: Clear narrative with proper paragraph structure, vocabulary appropriate for ${gradeLevel}
- Tone: Educational but engaging – it should encourage curiosity
- Do **not** include questions – only generate the passage text

**Note**: Ensure the passage allows for analysis-level comprehension and matches Bloom’s Taxonomy level: *Analyze*. Do not include any explanation or extra notes – only provide the passage.
`;

  return prompt;
}

export { generatePassagePrompt };

function generatePromptForImage({ Name, gradeLevel, domainData }) {
  const topics = Array.isArray(domainData)
    ? domainData.map(d => d.name).join(', ')
    : '';

  let prompt = `Generate a high-quality educational diagram suitable for a case study in the course "${Name}" at ${gradeLevel} level. 
  The diagram should depict a realistic or conceptual scenario related to the key topics of "${topics}" to be used to generate a question later. 
  Avoid including any text and questions within the image. 
  The visual must contain enough contextual detail to enable an AI assistant to generate at least 10 case-based multiple-choice questions. 
  Ensure the image is appropriate for ${gradeLevel} learners and reflects the core learning objectives of "${Name}" as defined by US Common Core Standards (Grades 1–12).`;

  // Clean whitespace and enforce 1000-character limit
  prompt = prompt.replace(/\s+/g, ' ').trim();
  if (prompt.length > 1000) {
    prompt = prompt.substring(0, 997) + '...';
  }

  return prompt;
}
export { generatePromptForImage };

